/**
 * Navegação lateral para as seções de relatórios
 */
import { cn } from '@/lib/utils';
import { Building2, Shield, FileCheck, Users } from 'lucide-react';
import { useRelatoriosFilters } from '../hooks';

interface Section {
  id: string;
  label: string;
  icon: React.ReactNode;
}

const sections: Section[] = [
  { id: 'imoveis', label: 'Imóveis', icon: <Building2 className="w-4 h-4" /> },
  { id: 'cenario-avcb', label: 'Cenário AVCB', icon: <Shield className="w-4 h-4" /> },
  { id: 'cenario-alvaras', label: 'Cenário Alvarás', icon: <FileCheck className="w-4 h-4" /> },
  { id: 'desempenho', label: 'Desempenho', icon: <Users className="w-4 h-4" /> },
];

interface SectionNavProps {
  className?: string;
}

export function SectionNav({ className }: SectionNavProps) {
  const { activeSection, setActiveSection } = useRelatoriosFilters();

  const handleClick = (sectionId: string) => {
    setActiveSection(sectionId);
    
    // Scroll suave para a seção
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className={cn('flex flex-col gap-1', className)}>
      <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-2 px-3">
        Seções
      </div>
      {sections.map((section) => (
        <button
          key={section.id}
          onClick={() => handleClick(section.id)}
          className={cn(
            'flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors text-left',
            activeSection === section.id
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted'
          )}
        >
          {section.icon}
          {section.label}
        </button>
      ))}
    </nav>
  );
}
